import {gql} from "@apollo/client";

export const myUniversityDegreesWithFilterQuery = gql`
    query myUniversityDegreesQuery(
        $universitySlug: String!
        $degreeLevel: String!
        $nameContains: String!
    ) {
        allDegrees(
            universitySlug: $universitySlug
            degreeLevel: $degreeLevel
            nameContains: $nameContains
        ) {
            id
            name
        }
    }
`;
